jQuery(document).ready(function ($) {
  $('.c-trader-bar__open-list').click(function () {
    $('.c-trader-bar__list-container').toggleClass('open').slideToggle(200);
    $(this).toggleClass('active');
    $('.c-trader-bar__arrow').toggleClass('open');
  });

  $(window).on('load', function () {
    $('.c-trader-bar__list').overlayScrollbars({
      className: 'os-theme-dark',
      resize: 'vertical',
      sizeAutoCapable: true,
      paddingAbsolute: true,
      scrollbars: {
        clickScrolling: true,
      },
    });
  });
});
